import { inject, Injectable } from '@angular/core';
import { type ActivatedRouteSnapshot, Router } from '@angular/router';
import { GameService } from '@dev-fast/backend-services';
import { Store } from '@ngxs/store';
import { type Observable, catchError, map, of, switchMap, take } from 'rxjs';

import { GamesState } from '@app/core/state/games-store';
import { IS_SERVER_TOKEN } from '@app/shared/utils';

@Injectable({
  providedIn: 'root',
})
export class IsGameActiveGuard {
  readonly #store = inject(Store);
  readonly #apiService = inject(GameService);
  readonly #isServer = inject<boolean>(IS_SERVER_TOKEN);
  readonly #router = inject(Router);

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    const allGames = this.#store.select(GamesState.gamesList);
    const gameKey = route.data['gameKey'];
    return this.#isServer
      ? of(true)
      : allGames.pipe(
        switchMap((games) => {
          if (!games.length) {
            return this.#apiService.getAvailableGames();
          }
          return of(games);
        }),
        take(1),
        map((games) => games.some((game) => game.name === gameKey && game.enabled)),
        catchError((e: any): Observable<any> => {
          this.#router.navigate([], { replaceUrl: true });
          return of(false);
        }),
      );
  }
}
